<template>
    <div class="container">
        <Date v-show="logged" v-on:currentDate="currentDateFunc"/>
        <h3 v-if="!logged">Alert system</h3>
        <Login v-if="!logged" v-on:setLogin="changeLogin"/>
        <MainApp v-if="logged && mainAppOn" v-bind:isAdmin="admin" v-bind:name="userData.name" v-on:startCMS="turnCMSon" v-on:logOut="turnLoginOut" v-on:startProfile="turnProfileOn" v-bind:currentDate="currentDate"/>
        <CMS v-if="logged && CMSon" v-on:returnFromCMS="turnMainAppOn" v-bind:userData="userData"/>
        <Profile v-if="logged && profileOn" v-on:returnFromCMS="turnMainAppOn" v-bind:userData="userData"/>
    </div>
</template>

<script>
import Login from './Login';
import MainApp from './MainApp';
import CMS from './CMS';
import Date from './Date';
import Profile from './Profile';
import crypto from 'crypto';
import axios from 'axios';
import {path} from '../../config';
export default {
    name: 'Alert',
    components: {
        Login,
        MainApp,
        CMS,
        Date,
        Profile
    },
    methods: {
        changeLogin: async function(user, password, isAdmin, name, id){
            this.logged = true;
            await this.saveLoginLog(name);
            this.mainAppOn = true;
            if(isAdmin){
                this.admin = true;
            }   else {
                this.admin = false;
            }
            this.$emit('logged');
            let hash = crypto.createHash('sha1');
            let data = hash.update(password, 'utf-8');
            let gen_hash = data.digest('hex');
            this.userData = {
                user: user,
                name: name,
                password: gen_hash,
                isAdmin: isAdmin,
                id: id,
            }
        },
        turnCMSon: function(){
            this.CMSon = true;
            this.mainAppOn = false;
        },
        turnProfileOn: function(){
            this.profileOn = true;
            this.mainAppOn = false;
        },
        turnMainAppOn: function(){
            this.CMSon = false;
            this.profileOn = false;
            this.mainAppOn = true;
        },
        turnLoginOut: function(){
            this.logged = false;
            this.mainAppOn = false;
            this.$emit('loggedOut');
        },
        currentDateFunc: function(date) {
            this.currentDate = date;
        },
        saveLoginLog: async function(name){
            let payload = {
                login: name,
                date: this.currentDate,
            }
            await axios
                .post(`${path}loginLog`, payload)
                .then(
                    )
                .catch(e => (
                    console.log(e)
                ))
        },
    },
    data: function(){
        return{
            logged: false,
            CMSon: false,
            mainAppOn: false,
            admin: false,
            userData: {},
            profileOn: false,
            currentDate: '',
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .container {
        max-width: 768px;
        padding-bottom: 50px;
    }
    h1 {
        color: red;
    }
</style>